import {
  Box,
  Button,
  FormHelperText,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { CustomEvent, Map } from "schemas/functions";

import styles from "features/Auth/Onboarding/styles";
import { TemplateHighlight } from "features/Influencer/Templates/TemplatesTable/CreateTemplate/schema";
import { makeDeepCopy } from "utils/updateLocalState";

interface PartnershipFormProps {
  handleBack?: () => void;
  handleNext?: () => void;
  handleSkip?: () => void;
  onboardingForm: Map;
  setOnboardingForm: Dispatch<SetStateAction<Map>>;
  isProfilePage?: boolean;
}

const PartnershipForm = ({
  handleBack,
  handleNext,
  handleSkip,
  onboardingForm,
  setOnboardingForm,
  isProfilePage = false,
}: PartnershipFormProps) => {
  const onSubmit = (e: CustomEvent) => {
    e.preventDefault();
    if (handleNext) handleNext();
  };

  const handleChange = (e: CustomEvent) => {
    const { name, value } = e.target;

    const copy = makeDeepCopy(onboardingForm);
    copy[name] = value;
    setOnboardingForm(copy);
  };

  return (
    <form onSubmit={onSubmit}>
      {!isProfilePage && (
        <Typography
          variant="h3"
          gutterBottom
          sx={{ textAlign: "center", mb: 3 }}
        >
          <Box
            component="i"
            color="secondary.dark"
            sx={{ pr: 2 }}
            className="fa-solid fa-handshake-angle"
          />
          Past Partnerships
        </Typography>
      )}

      {(isProfilePage ||
        onboardingForm.defaultTemplateHighlights.includes(
          TemplateHighlight.CASE_STUDY,
        )) && (
        <Grid item xs={12}>
          <FormHelperText sx={styles.helperText}>
            Share an example of a past partnership and the results you created
            for them (share an example link if relevant)
          </FormHelperText>
          <TextField
            sx={styles.textField}
            fullWidth
            name="caseStudy"
            placeholder="I worked with Wayfair on an ad that generated 2M views!"
            onChange={handleChange}
            multiline
            minRows={2}
            value={onboardingForm?.caseStudy || ""}
          />
        </Grid>
      )}

      {(isProfilePage ||
        onboardingForm.defaultTemplateHighlights.includes(
          TemplateHighlight.PAST_PARTNERSHIPS,
        )) && (
        <Grid item xs={12}>
          <FormHelperText sx={styles.helperText}>
            Share 3-4 solid brands that you want to mention in your pitch
          </FormHelperText>
          <TextField
            sx={styles.textField}
            fullWidth
            name="mostImpressivePartnerships"
            placeholder="Skims, Motion, Amazon and Wayfair"
            onChange={handleChange}
            value={onboardingForm?.mostImpressivePartnerships || ""}
          />
        </Grid>
      )}

      {!isProfilePage && (
        <Grid
          container
          justifyContent="flex-start"
          columnGap={1}
          sx={{ mt: 2 }}
        >
          <Grid item xs="auto">
            <Button onClick={handleBack} color="secondary" disableElevation>
              Back
            </Button>
          </Grid>
          <Grid item xs></Grid>
          {handleSkip && (
            <Grid item xs="auto">
              <Button onClick={handleSkip} color="secondary" disableElevation>
                Skip
              </Button>
            </Grid>
          )}
          <Grid item xs="auto">
            <Button disableElevation type="submit" variant="contained">
              Next
            </Button>
          </Grid>
        </Grid>
      )}
    </form>
  );
};

export default PartnershipForm;
